<template>
  <div id="content" class="content">
    <Transition name="slide">
      <MenuComponent v-if="UIStore.getIsMenuOpen" ref="menuRef" />
    </Transition>
    <header class="header" :class="[{ collapsed: UIStore.getIsMenuOpen }]">
      <button type="button" @click.capture="toggleMenu">
        <SvgIcon icon="menu" />
      </button>
      <FilterComponent v-if="isFilter" />
      <div class="header__container">
        <SubscriptionControl v-if="!isAdmin" />
        <component :is="isAdmin ? 'p' : 'RouterLink'" to="/profile" class="header__link">
          {{ authStore.user?.name ?? 'Admin' }}
        </component>
        <ContextMenu
          :items="menuItems"
          class="header__context-menu"
          @logout="logout"
          @adminLogout="adminLogout"
        >
          <!-- @vue-ignore -->
          <template #icon>
            <button type="button">
              <SvgIcon icon="chevron-down" />
            </button>
          </template>
        </ContextMenu>
      </div>
    </header>
    <main class="main" :class="[{ collapsed: UIStore.getIsMenuOpen }]">
      <slot />
    </main>
    <CallWidget v-if="!isAdminPages" />
  </div>
</template>

<script lang="ts" src="./MainLayout.ts"></script>

<style lang="scss" src="./MainLayout.scss"></style>
